import AppEditorMixin from "@/protected/mixins/AppEditorMixin";
import AttachmentsForm, {
  onAttachmentEvent,
  onAttachmentsTabSelected
} from "@/protected/components/AttachmentsForm";
import MessagesForm, {
  onMessage,
  onMessagesTabSelected
} from "@/protected/components/MessagesForm";
import InfoForm from "./InfoForm";
//import HelpForm from "./HelpForm";
import LogEntriesForm from "./LogEntriesForm";
//import { beep } from 'core/utils';

const attachmentsContextList = self => [
  // =====================================================================
  // Allegati richiesta
  // =====================================================================
  {
    label: "Allegati richiesta - Visibilità: Gestori/Clienti/Fornitori",
    serverPath: self.requestContextServerPath,
    subcontext: "BROKER_CUSTOMER_PROVIDER",
    getId: value => value.id,
    getPermissions: value =>
      value.permissions.attachments.BROKER_CUSTOMER_PROVIDER,
    message:
      "I file caricati in questa sezione sono visibili da " +
      '<strong class="text-success">gestori</strong>, ' +
      '<strong class="text-success">clienti</strong> e ' +
      '<strong class="text-success">fornitori</strong> e sono ' +
      "richiamabili da " +
      '<strong class="text-dark">ogni pratica</strong> ' +
      "collegata a questa " +
      '<strong class="text-primary">richiesta</strong>.'
  },
  {
    label: "Allegati richiesta - Visibilità: Gestori/Clienti",
    serverPath: self.requestContextServerPath,
    subcontext: "BROKER_CUSTOMER",
    getId: value => value.id,
    getPermissions: value => value.permissions.attachments.BROKER_CUSTOMER,
    message:
      "I file caricati in questa sezione sono visibili solamente " +
      'da <strong class="text-success">gestori</strong> e ' +
      '<strong class="text-success">clienti</strong>, ma ' +
      'non dai <strong class="text-danger">fornitori</strong> ' +
      "e sono richiamabili da " +
      '<strong class="text-dark">ogni pratica</strong> ' +
      "collegata a questa " +
      '<strong class="text-primary">richiesta</strong>.'
  },
  // =====================================================================
  // Allegati cliente
  // =====================================================================
  {
    label: "Allegati cliente - Visibilità: Gestori/Clienti/Fornitori",
    serverPath: "customers",
    subcontext: "BROKER_CUSTOMER_PROVIDER",
    //    externalContext: self.externalContext,
    getId: value => value.customer.id,
    //    getExternalContextId: (value) => value.id,
    getPermissions: value =>
      value.permissions.customerAttachments.BROKER_CUSTOMER_PROVIDER,
    message:
      "I file caricati in questa sezione sono visibili da " +
      '<strong class="text-success">gestori</strong>, ' +
      '<strong class="text-success">clienti</strong> e ' +
      '<strong class="text-success">fornitori</strong> e sono ' +
      "richiamabili da " +
      '<strong class="text-dark">ogni pratica</strong> ed ' +
      '<strong class="text-dark">ogni richiesta</strong> ' +
      "collegate a questo " +
      '<strong class="text-primary">cliente</strong>.'
  },
  {
    label: "Allegati cliente - Visibilità: Gestori/Clienti",
    serverPath: "customers",
    subcontext: "BROKER_CUSTOMER",
    //externalContext: self.externalContext,
    getId: value => value.customer.id,
    //getExternalContextId: (value) => value.id,
    getPermissions: value =>
      value.permissions.customerAttachments.BROKER_CUSTOMER,
    message:
      "I file caricati in questa sezione sono visibili da " +
      '<strong class="text-success">gestori</strong> e ' +
      '<strong class="text-success">clienti</strong> ma non dai ' +
      '<strong class="text-danger">fornitori</strong> e sono ' +
      "richiamabili da " +
      '<strong class="text-dark">ogni pratica</strong> ed ' +
      '<strong class="text-dark">ogni richiesta</strong> ' +
      "collegate a questo " +
      '<strong class="text-primary">cliente</strong>.'
  },
  // =====================================================================
  // Allegati rete
  // =====================================================================
  {
    label: "Allegati agenzia - Visibilità: Gestori/Clienti/Fornitori",
    serverPath: "networks",
    subcontext: "BROKER_CUSTOMER_PROVIDER",
    //externalContext: self.externalContext,
    getId: value => value.network.id,
    //getExternalContextId: (value) => value.id,
    getPermissions: value =>
      value.permissions.networkAttachments.BROKER_CUSTOMER_PROVIDER,
    message:
      "I file caricati in questa sezione sono visibili da " +
      '<strong class="text-success">gestori</strong>, ' +
      '<strong class="text-success">clienti</strong> e ' +
      '<strong class="text-success">fornitori</strong> e sono ' +
      "richiamabili da " +
      '<strong class="text-dark">ogni pratica</strong> ed ' +
      '<strong class="text-dark">ogni richiesta</strong> ' +
      "collegate a questa " +
      '<strong class="text-primary">agenzia</strong>.'
  },
  {
    label: "Allegati agenzia - Visibilità: Gestori/Clienti",
    serverPath: "networks",
    subcontext: "BROKER_CUSTOMER",
    //externalContext: self.externalContext,
    getId: value => value.network.id,
    //getExternalContextId: (value) => value.id,
    getPermissions: value =>
      value.permissions.networkAttachments.BROKER_CUSTOMER,
    message:
      "I file caricati in questa sezione sono visibili da " +
      '<strong class="text-success">gestori</strong> e ' +
      '<strong class="text-success">clienti</strong> ma non dai ' +
      '<strong class="text-danger">fornitori</strong> e sono ' +
      "richiamabili da " +
      '<strong class="text-dark">ogni pratica</strong> ed ' +
      '<strong class="text-dark">ogni richiesta</strong> ' +
      "collegate a questa " +
      '<strong class="text-primary">agenzia</strong>.'
  },
  {
    label: "Allegati agenzia - Visibilità: Gestori/Fornitori",
    serverPath: "networks",
    subcontext: "BROKER_PROVIDER",
    //externalContext: self.externalContext,
    getId: value => value.network.id,
    //getExternalContextId: (value) => value.id,
    getPermissions: value =>
      value.permissions.networkAttachments.BROKER_PROVIDER,
    message:
      "I file caricati in questa sezione sono visibili da " +
      '<strong class="text-success">gestori</strong> e ' +
      '<strong class="text-success">fornitori</strong> ma non dai ' +
      '<strong class="text-danger">clienti</strong> e sono ' +
      "richiamabili da " +
      '<strong class="text-dark">ogni pratica</strong> ed ' +
      '<strong class="text-dark">ogni richiesta</strong> ' +
      "collegate a questa " +
      '<strong class="text-primary">agenzia</strong>.'
  }
];

const messagesContextList = self => [
  {
    label: "Messaggi richiesta - Visibilità: Gestori/Clienti",
    serverPath: self.requestContextServerPath,
    subcontext: "BROKER_CUSTOMER",
    getId: value => value.id,
    getPermissions: value => value.permissions.messages.BROKER_CUSTOMER,
    message:
      "I messaggi scambiati in questa chat sono visibili solamente " +
      'da <strong class="text-success">gestori</strong> e ' +
      '<strong class="text-success">clienti</strong>, ma ' +
      'non dai <strong class="text-danger">fornitori</strong> ' +
      "e sono richiamabili da " +
      '<strong class="text-dark">ogni pratica</strong> ' +
      "collegata a questa " +
      '<strong class="text-primary">richiesta</strong>.'
  },
  {
    label: "Messaggi richiesta - Visibilità: Gestori/Clienti/Fornitori",
    serverPath: self.requestContextServerPath,
    subcontext: "BROKER_CUSTOMER_PROVIDER",
    getId: value => value.id,
    getPermissions: value =>
      value.permissions.messages.BROKER_CUSTOMER_PROVIDER,
    message:
      "I messaggi scambiati in questa chat sono visibili da " +
      '<strong class="text-success">gestori</strong>, ' +
      '<strong class="text-success">clienti</strong> e ' +
      '<strong class="text-success">fornitori</strong> e sono ' +
      "richiamabili da " +
      '<strong class="text-dark">ogni pratica</strong> ' +
      "collegata a questa " +
      '<strong class="text-primary">richiesta</strong>.'
  }
];

export default {
  mixins: [AppEditorMixin],

  computed: {
    tabs() {
      return [
        /*
        {
          component: HelpForm,
          title: () => this.$t('request.tabs.help'),
          icon: 'question'
        },
        */
        {
          component: this.RequestForm,
          title: () => this.$t("request.tabs.main"),
          icon: "file"
        },
        {
          component: InfoForm,
          title: () => this.$t("request.tabs.info"),
          icon: "info"
        },
        {
          id: "attachments",
          component: AttachmentsForm,
          title: () => this.$t("request.tabs.attachments"),
          icon: "paperclip",
          show: !this.isNew,
          props: {
            contextList: attachmentsContextList(this)
          },
          events: {
            "attachment-event": onAttachmentEvent.bind(this)
          },
          tabSelected: onAttachmentsTabSelected.bind(this)
        },
        {
          id: "messages",
          component: MessagesForm,
          show: !this.isNew,
          title: () => this.$t("request.tabs.messages"),
          icon: "comments",
          props: {
            contextList: messagesContextList(this)
          },
          events: {
            message: onMessage.bind(this)
          },
          tabSelected: onMessagesTabSelected.bind(this)
        },
        {
          component: LogEntriesForm,
          title: () => this.$t("request.tabs.logEntries"),
          icon: "clock"
        }
      ];
    }
  }
};
